import React, { FC } from 'react';
import { View } from 'react-native';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';

interface ProductionOrderDetailsBatchEventsActiveProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const ProductionOrderDetailsBatchEventsActiveComponent: FC<ProductionOrderDetailsBatchEventsActiveProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  batch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  const productionBatchId = batch.data?.productionBatchId;

  return (
    <DetailsPageWrapper title={title.batch}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.ACTIVE, productionBatchId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsBatchEventsActive = connect(({ batch: { batch } }) => ({ batch }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsBatchEventsActiveComponent);

export { ProductionOrderDetailsBatchEventsActive };
